import { fetchHospitalitySnapshot } from '../../hospitality/infra/hospitalityRepo';
import { printKitchenComandaSafe } from './printComandaDocuments';
import { shouldAutoPrintKitchenComanda } from './printOrchestrator';

/** Imprime comanda si Dispositivos → auto comanda está ON (mismo transporte que tickets). */
export async function autoPrintKitchenComandaIfEnabled(args: {
  branchId: string;
  ticketId: string | null;
  diningTableId: string | null;
  onError?: (title: string, message: string) => void;
}): Promise<void> {
  if (!args.ticketId) return;
  if (!(await shouldAutoPrintKitchenComanda(args.branchId))) return;
  const snap = await fetchHospitalitySnapshot(args.branchId, 30);
  const ticket = snap.kitchenTickets.find((t) => t.id === args.ticketId);
  if (!ticket) return;
  const tableName = args.diningTableId
    ? snap.diningTables.find((t) => t.id === args.diningTableId)?.name
    : undefined;
  await printKitchenComandaSafe({
    branchId: args.branchId,
    ticket,
    tableName,
    onError: args.onError ?? (() => {}),
  });
}
